import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "@i18n";
import { Icon } from "@syarahtech/ui";
import useIsMobile from "@/common/hooks/useIsMobile";
import WarrantyOptionRow from "./WarrantyCard/WarrantyOptionRow";
import WarrantySelectionDrawer from "./WarrantyCard/WarrantySelectionDrawer";
import Markdown from "markdown-to-jsx";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
var WarrantyRemaining = function WarrantyRemaining(_ref) {
  var _options;
  var warranty = _ref.warranty,
    options = _ref.options,
    onSelect = _ref.onSelect,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$isDefaultSelecte = _ref.isDefaultSelected,
    isDefaultSelected = _ref$isDefaultSelecte === void 0 ? false : _ref$isDefaultSelecte,
    referral_location = _ref.referral_location,
    order_id = _ref.order_id,
    order_type = _ref.order_type;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(false),
    isExpanded = _useState[0],
    setIsExpanded = _useState[1];
  var _useState2 = useState(false),
    isDrawerOpen = _useState2[0],
    setIsDrawerOpen = _useState2[1];
  var isFree = !warranty.price || (warranty === null || warranty === void 0 ? void 0 : warranty.price) == "0";
  var isHighestPackage = options.length > 0 && ((_options = options[options.length - 1]) === null || _options === void 0 ? void 0 : _options.id) === warranty.id;
  var handleToggle = function handleToggle() {
    trackEvents('warranty_list_opened', {
      order_id: order_id,
      referral_location: referral_location,
      order_type: order_type
    });
    if (isMobile) {
      setIsDrawerOpen(true);
    } else {
      setIsExpanded(function (prev) {
        return !prev;
      });
    }
  };
  var handleConfirm = function handleConfirm(option) {
    setIsExpanded(false);
    trackEvents('warranty_selected', {
      order_id: order_id,
      referral_location: referral_location,
      order_type: order_type,
      selected_warranty: option === null || option === void 0 ? void 0 : option.years
    });
    return onSelect(option);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg border border-gray-gainsboro border-solid px-4 py-3 flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse bg-gray-200 rounded h-6 w-24"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-gray-text text-sm font-medium leading-6"
  }, tShort("remaining/car_warranty", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("div", {
    className: "bg-violet-light px-1 rounded"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-violet text-sm font-bold leading-6"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "[&>strong]:font-bold"
  }, warranty.name)))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 flex-col-reverse"
  }, isLoading ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-end gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse bg-gray-200 rounded h-6 w-16"
  }), /*#__PURE__*/React.createElement("div", {
    className: "animate-pulse bg-gray-200 rounded h-4 w-12"
  })) : isFree ? /*#__PURE__*/React.createElement("span", {
    className: "text-gray-cool text-sm font-medium"
  }, tShort("remaining/free", {
    ns: "web_tracking"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, warranty.original_price && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5 opacity-80"
  }, /*#__PURE__*/React.createElement(Markdown, {
    className: "text-[0px] relative [&_del]:text-sm [&_del]:font-bold [&_del]:leading-6 [&_del]:text-gray-cool [&_del]:no-underline [&_del]:relative [&_del]:after:content-[''] [&_del]:after:absolute [&_del]:after:inset-x-0 [&_del]:after:top-[50%] [&_del]:after:h-px [&_del]:after:bg-current [&_.syarah-currency-icon]:text-sm [&_.syarah-currency-icon]:text-gray-cool"
  }, warranty.original_price)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-navy-primary text-lg font-bold leading-7 tracking-tight"
  }, warranty.price))))), options.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "h-px bg-gray-gainsboro"
  }), options.length <= 1 ? null : /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleToggle,
    className: "flex justify-center items-center cursor-pointer gap-1 bg-transparent border-none p-0"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-moderator-outline-rounded",
    width: 6,
    height: 6,
    className: "text-violet"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary-new text-sm font-bold leading-5 tracking-tight"
  }, isHighestPackage ? tShort("remaining/change_warranty_duration", {
    ns: "web_tracking"
  }) : tShort("remaining/extend_warranty", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--keyboard-arrow-down-rounded",
    className: "text-primary-new transition-transform duration-200 ".concat(isExpanded ? "rotate-180" : ""),
    width: 5,
    height: 5
  }))), /*#__PURE__*/React.createElement(AnimatePresence, {
    initial: false
  }, !isMobile && isExpanded && /*#__PURE__*/React.createElement("div", {
    className: "flex gap-4 flex-col w-full"
  }, /*#__PURE__*/React.createElement(motion.div, {
    key: "warranty-options",
    initial: {
      height: 0,
      opacity: 0
    },
    animate: {
      height: "auto",
      opacity: 1
    },
    exit: {
      height: 0,
      opacity: 0
    },
    transition: {
      duration: 0.25,
      ease: "easeInOut"
    },
    className: "w-full flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3 pt-1 w-full"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(WarrantyOptionRow, {
      key: option.id,
      option: option,
      isSelected: warranty.id === option.id,
      onSelect: function onSelect(o) {
        handleConfirm(o);
      }
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center text-sm font-medium leading-5"
  }, tShort("warranty/options_note", {
    ns: "web_tracking"
  })))))), isMobile && /*#__PURE__*/React.createElement(WarrantySelectionDrawer, {
    open: isDrawerOpen,
    onClose: function onClose() {
      return setIsDrawerOpen(false);
    },
    options: options,
    selectedId: warranty.id,
    isDefaultSelected: isDefaultSelected,
    onConfirm: handleConfirm
  }));
};
export default WarrantyRemaining;